import React from "react"
import "./style.css"

const name = "StepNumberIcon"

type StepNumberIconProps = {
    number: string
    variant: "green" | "orange" | "red"
}

const StepNumberIcon: React.FC<StepNumberIconProps> = ({ number, variant }) => {
    return (
        <span className="MuiStepLabel-iconContainer">
            <svg className={`MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiStepIcon-root Mui-active ${variant}`} focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="12"></circle>
                <text className={`StepNumberIcon-text ${variant}`} x="12" y="16" textAnchor="middle">{number}</text>
            </svg>
        </span>
    )
}

StepNumberIcon.displayName = name;


export default React.memo(StepNumberIcon);
